<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="512px"
    height="512px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 512 512"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <!-- <defs>
      <style type="text/css">
        <![CDATA[
         .fil0 {fill:#2B2A29}
        ]]>
      </style>
    </defs> -->
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2716482426176">
        <path
          class="fil0"
          d="M36.19 64.28l12.24 0 0 15.96c0,17.7 14.51,32.19 32.24,32.19l0 0c17.73,0 32.24,-14.49 32.24,-32.19l0 -15.96 191.16 0 0 15.96c0,17.7 14.5,32.19 32.24,32.19l0 0c17.73,0 32.24,-14.49 32.24,-32.19l0 -15.96 14.33 0c19.91,0 36.2,16.26 36.2,36.13l0 125.36 -33.34 0 0 -64.95 -352.4 0 0 223.18 191.94 0 0 32.76 -189.09 0c-19.9,0 -36.19,-16.26 -36.19,-36.13l0 -280.22c0,-19.87 16.29,-36.13 36.19,-36.13z"
        />
        <path
          class="fil0"
          d="M65.05 288.5l63.18 0 0 63.88 -63.18 0 0 -63.88zm0 -96.69l63.18 0 0 63.87 -63.18 0 0 -63.87zm191.62 0l63.18 0 0 63.87 -63.18 0 0 -63.87zm-95.81 0l63.18 0 0 63.87 -63.18 0 0 -63.87zm0 96.69l63.18 0 0 63.88 -63.18 0 0 -63.88z"
        />
        <path
          class="fil0"
          d="M383.62 255.68c70.9,0 128.38,57.38 128.38,128.16 0,70.78 -57.48,128.16 -128.38,128.16 -70.9,0 -128.38,-57.38 -128.38,-128.16 0,-70.78 57.48,-128.16 128.38,-128.16zm0 31.92c53.24,0 96.41,43.09 96.41,96.24 0,53.15 -43.17,96.24 -96.41,96.24 -53.25,0 -96.41,-43.09 -96.41,-96.24 0,-53.15 43.16,-96.24 96.41,-96.24z"
        />
        <path
          class="fil0"
          d="M368.48 320.44l0 0c8.78,0 15.96,7.17 15.96,15.93l0 48.54 48.72 0c8.78,0 15.96,7.17 15.96,15.93l0 0c0,8.77 -7.18,15.94 -15.96,15.94l-64.56 0c-0.97,0 -1.92,-0.09 -2.84,-0.26 -7.49,-1.3 -13.24,-7.86 -13.24,-15.7l0 -64.45c0,-8.76 7.18,-15.93 15.96,-15.93z"
        />
        <path
          class="fil0"
          d="M80.67 0l0 0c8.72,0 15.86,7.12 15.86,15.83l0 64.41c0,8.71 -7.14,15.83 -15.86,15.83l0 0c-8.72,0 -15.85,-7.12 -15.85,-15.83l0 -64.41c0,-8.71 7.13,-15.83 15.85,-15.83zm255.64 0l0 0c8.72,0 15.85,7.12 15.85,15.83l0 64.41c0,8.71 -7.13,15.83 -15.85,15.83l0 0c-8.72,0 -15.86,-7.12 -15.86,-15.83l0 -64.41c0,-8.71 7.14,-15.83 15.86,-15.83z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
